import React, { useContext, useEffect, useState } from 'react'
import { jobTab, jobTab1 } from '../../data/data';
import { makeGetCall, makeNextPageCall, makePostCall } from '../../effects/requests';
import Tabs from '../../global/ui/Tabs';
import { ApiResponseType, JOB_STATUS, USER_PRESS_ACTION_TYPE, NUMBER_STATUS } from '../../types';
import { endPoints } from '../../utils/endpoints';
import JobInfo from './JobInfo';
import RelevantCrew from './RelevantCrew';
import { MyContext } from '../../context';
import { isProdUser, isSuperUser } from '../../utils';

interface ViewJobDetailProps {
    visible: any;
    onClose: () => void;
    onDone: () => void;
    jobDetails: any
    onAction: (type: any) => void
}

const ViewJobDetail: React.FC<ViewJobDetailProps> = (props) => {

    const [showMoreMenu, setShowMoreMenu] = useState(false);
    const [crewList, setCrewList] = useState([]);
    const [selectedCrew, setSelectedCrew] = useState<any>([]);
    const [jobStatus, setJobStatus] = useState<JOB_STATUS>(props.jobDetails?.completed ? 'Accepted' : 'Relevant');
    const [nextUrl, setNextUrl] = useState(null);
    const [selectedIdx, setSelectedIdx] = useState(0);
    const [searchRelevant, setSearchRelevant] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { userData } = useContext(MyContext)

    useEffect(() => {
        if (props.jobDetails?.id) {
            if (props.jobDetails?.completed) {
                getInvitedCrews(props.jobDetails?.id, NUMBER_STATUS.STATUS_2)
            } else {
                setSearchRelevant('')
                getCrewMem(props.jobDetails?.id, "");
            }
            setShowMoreMenu(false)
        }
    }, [props.jobDetails?.id]);

    const getCrewMem = (id: string, text: string) => {
        if (id) {
            makeGetCall(endPoints.JOB_REQUEST, { job: id, search: text }).then((res: ApiResponseType<any>) => {
                setCrewList(res?.results);
                setNextUrl(res?.next);
                setSelectedCrew([])
            })
        }
    }

    const fetchMoreDetails = () => {
        if (!nextUrl) return;
        setIsLoading(true)
        makeNextPageCall(nextUrl, false, true).then((res: ApiResponseType<any>) => {
            setIsLoading(false)
            const crewInfoList = [...crewList, ...res.results];
            setNextUrl(res?.next);
            setCrewList(crewInfoList as never)
        }).catch((err) => setIsLoading(false))
    }
    const getInvitedCrews = (id: string, status: any) => {
        makeGetCall(endPoints.JOB_INVITE, { job: id, status: status }).then((res: ApiResponseType<any>) => {
            if (res?.results?.length > 0) {
                const tempData = res.results.map((item: any) => {
                    item = { ...item, ...item?.crew_member };
                    return item
                })
                setCrewList(tempData);
                setSelectedCrew([]);
                setNextUrl(null);
            } else {
                setCrewList([]);
                setSelectedCrew([]);
                setNextUrl(null);
            }
        })
    }

    const handleAssignJob = () => {
        selectedCrew.map((id: any, idx: any) => {
            const payload = {
                job: props.jobDetails?.id || '',
                crew_member: id || ''
            }
            makePostCall(endPoints.JOB_REQUEST, payload).then((res: ApiResponseType<any>) => {
                if (idx === selectedCrew?.length - 1) {
                    props?.onDone?.()
                }
            })
        })
    }

    const renderCrew = (type: JOB_STATUS) => {
        switch (type) {
            case 'Relevant':
                return <RelevantCrew
                    data={crewList}
                    selectedCrew={selectedCrew}
                    fetchMoreDetails={fetchMoreDetails}
                    nextUrl={nextUrl}
                    onChange={(data) => {
                        const tempCrew = [...selectedCrew];
                        const index = tempCrew.findIndex(id => id === data?.id)
                        if (index === -1) {
                            tempCrew.push(data?.id as never)
                        } else {
                            tempCrew.splice(index, 1)
                        }
                        setSelectedCrew(tempCrew)
                    }}
                    searchRelevant={searchRelevant}
                    setSearchRelevant={(value?: any) => {
                        setSearchRelevant(value)
                        getCrewMem(props.jobDetails?.id, value);
                    }}
                    type={"Relevent"}
                    closeMainPopup={() => props.onClose()}
                    isLoading={isLoading}
                    hideCheckbox={!isProdUser(userData)}
                />

            case 'Accepted':
            case 'Invited':
            case 'Rejected':
                return <RelevantCrew
                    data={crewList}
                    hideCheckbox
                    fetchMoreDetails={fetchMoreDetails}
                    nextUrl={nextUrl}
                    isLoading={isLoading}
                />
        }
    }

    useEffect(() => {
        if (props.jobDetails?.completed) setJobStatus('Accepted')
        else setJobStatus('Relevant')
    }, [props.jobDetails?.completed])

    return (
        <div className={`right-side-popup-background  ${props.visible ? "" : "d-none"} `}>
            <div className={selectedCrew?.length > 0 ? "right-side-popup-fixed d-grid align-content-between gap-4 relevant-members-hegiht" : "right-side-popup-fixed d-grid align-content-between gap-4"}>
                <div className="right-side-popup-main-top mh-100">
                    <div className="popup-right-side-top">
                        <div className='cross-and-dropdonw-selct d-flex justify-content-between align-items-center mb-0'>
                            <img src={"/assets/images/dismiss-cross-black.svg"} alt="" className="img-cross-icon" onClick={() => { props.onClose(); setSelectedIdx(0) }} />
                            {!props.jobDetails?.completed && isProdUser(userData) || isSuperUser(userData) &&
                                <div className='filter-select'>
                                    <img src={"/assets/images/more-three-dots.svg"} className="main-drop-donwe" onClick={() => setShowMoreMenu((prvState) => !prvState)} alt="" />
                                    <div className={`drop-down-dtost  ${showMoreMenu ? "d-block" : "d-none"} `}>
                                        <ul className="d-grid list-unstyled pl-0 mb-0">
                                            <li onClick={() => props.onAction(USER_PRESS_ACTION_TYPE.TYPE_UPDATE)}><img src={"/assets/images/edit-pencil-black.svg"} alt="" /> Edit Job Post</li>
                                            {isProdUser(userData) &&
                                                <>
                                                    <li onClick={() => props.onAction(USER_PRESS_ACTION_TYPE.TYPE_COMPLETE)}><img src={"/assets/images/Checkmark-Circle.svg"} alt="" /> Complete Job</li>
                                                    <li onClick={() => props.onAction(USER_PRESS_ACTION_TYPE.TYPE_DELETE)}><img src={"/assets/images/Delete-icon-red.svg"} alt="" /> Remove Job</li>
                                                </>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }
                        </div>
                        <JobInfo jobDetails={props.jobDetails} />
                    </div>
                    <div className="bottom-tabs-wo">
                        <Tabs
                            data={props.jobDetails?.completed ? jobTab1 : jobTab}
                            selectedIdx={selectedIdx}
                            onClick={(value: JOB_STATUS, idx: any) => {
                                setSelectedIdx(idx)
                                setJobStatus(value)
                                setSearchRelevant('')
                                if (value === 'Accepted' || value === 'Rejected' || value === 'Invited') {
                                    getInvitedCrews(props?.jobDetails?.id, value === 'Accepted' ? NUMBER_STATUS.STATUS_2 : value === 'Invited' ? NUMBER_STATUS.STATUS_1 : NUMBER_STATUS.STATUS_3)
                                } else {
                                    getCrewMem(props.jobDetails?.id, "");
                                }
                            }}
                        />
                        {renderCrew(jobStatus)}
                    </div>
                </div>
                {selectedCrew?.length > 0 && isProdUser(userData) &&
                    <div className="right-side-popup-button">
                        <ul className="d-flex list-unstyled gap-3 justify-content-between align-item-center w-100 mb-0">
                            <li className="w-100">
                                <button style={{ bottom: '30px' }} type='button' onClick={handleAssignJob} className="common_btn btn btn-warning w-100 with-after-shadow shadow-none">Invite</button>
                            </li>
                        </ul>
                    </div>
                }
            </div>
        </div>
    )
}

export default ViewJobDetail